(() => {
  function init(root) {
    if (root.dataset.vfBound) return;
    root.dataset.vfBound = 'true';
    const columns = [...root.querySelectorAll('.vf-column')];
    const desktop = matchMedia('(min-width: 901px)');
    const sync = () => columns.forEach(column => column.open = desktop.matches);
    sync();
    desktop.addEventListener('change', sync);
    columns.forEach(column => column.querySelector('summary').addEventListener('click', event => { if (desktop.matches) event.preventDefault(); }));
    root.querySelector('[data-vf-top]')?.addEventListener('click', () => {
      window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      document.querySelector('.vn-brand')?.focus({preventScroll:true});
    });
  }
  const mount = () => document.querySelectorAll('[data-vf-footer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
